import { EXERCISE_VIDEOS } from './exerciseVideos';

/**
 * Normalises an exercise name for video lookup.
 *
 * Mirrors `video_key` in scripts/build_program_data.py — the two must agree or
 * nothing matches. Names reach us with list numbering ("1. Machine Row") and
 * superset markers ("A1: Sissy Squat") attached, neither of which is part of
 * the exercise's identity.
 */
export function videoKey(name: string): string {
  return name
    .replace(/\n/g, ' ')
    .trim()
    .replace(/^\d+\.\s*/, '')
    .replace(/^[A-Z][12]:\s*/, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

/** The demo video for an exercise, or null when there isn't one. */
export function videoFor(name: string | null | undefined): string | null {
  if (!name) return null;
  return EXERCISE_VIDEOS[videoKey(name)] ?? null;
}
